import React, { PropTypes, Component } from 'react';
import bemHelper from 'react-bem-helper';

const bem = bemHelper({ prefix: 'toga-', name: 'currency' });

class Currency extends Component {
  static symbols = {
    GBP: '£',
    EUR: '€',
    USD: '$',
    AUD: '$',
  };

  render() {
    const { onSale, isPlaceholder } = this.props;
    const symbol = Currency.symbols[this.props.code];

    return (<div {...bem(null, { sale: onSale, placeholder: isPlaceholder })}>{symbol}</div>);
  }
}

Currency.propTypes = {
  code: PropTypes.string.isRequired,
  onSale: PropTypes.bool,
};

export default Currency;



// WEBPACK FOOTER //
// ./src/subComponents/currency/index.js